import { render, staticRenderFns } from "./InvoicesTableBlock.vue?vue&type=template&id=455622d6&scoped=true"
import script from "./InvoicesTableBlock.vue?vue&type=script&lang=js"
export * from "./InvoicesTableBlock.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTableBlock.vue?vue&type=style&index=0&id=455622d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455622d6",
  null
  
)

export default component.exports